module.exports = __webpack_public_path__ + "static/media/ds-smith-logo.79203a2a.png";